export const analyzes = {
    //* 日期解析函数
    date: (date?: Date) => {
        if (!date) return undefined;
        else {
            const result = new Date(date);
            if (result.toString() == "Invalid Date") return undefined;
            else {
                return result;
            }
        }
    },

    //* 日期转字符串
    string: (mode: string, date?: Date) => {
        if (!date || date.toString() == "Invalid Date") return "";
        else {
            //* 初始化时间数据
            const cYear = date.getFullYear();
            const cDate = date.getDate().toString().padStart(2, "0");
            const cMonth = (date.getMonth() + 1).toString().padStart(2, "0");
            const cHours = date.getHours().toString().padStart(2, "0");
            const cMinutes = date.getMinutes().toString().padStart(2, "0");
            const cSeconds = date.getSeconds().toString().padStart(2, "0");
            //* 数据返回
            if (mode == "time") return `${cYear}-${cMonth}-${cDate} ${cHours}:${cMinutes}:${cSeconds}`;
            else {
                return `${cYear}-${cMonth}-${cDate}`;
            }
        }
    },

    //* 获取正确顺序的日期
    get_correct_date: (data: { start?: Date; end?: Date }) => {
        const result = { start: data.start, end: data.end };
        if (result.start && result.end && result.start.getTime() > result.end.getTime()) {
            result.start = data.end;
            result.end = data.start;
        }

        return result;
    },

    //* 获取当前月份的起始日期
    get_month_start_date: (date: Date) => {
        //* 数据初始化
        const result = new Date(date.getFullYear(), date.getMonth(), 1);
        const day = result.getDay();
        if (day == 0) result.setDate(result.getDate() - 6);
        else {
            result.setDate(result.getDate() - (day - 1));
        }

        return result;
    },
};
